import { createTRPCReact } from '@trpc/react-query';

// DETTE TECHNIQUE B.6 : ce fichier est en JS (pas TS) car web-legacy est CRA-JS.
// La type-safety end-to-end tRPC nécessite `createTRPCReact<AppRouter>()`
// avec import type depuis services/api. Sera fixé en F.1 (migration TS progressive).
// Pour l'instant : tRPC sert de transport HTTP type-erased. Les usages devront
// vérifier manuellement les noms de procedures et formes d'inputs/outputs.
export const trpc = createTRPCReact();
